(function() {
    angular
        .module("app")
        .factory("feedbackService", feedbackService)

    feedbackService.$inject = [
        "$rootScope",
        "$http"
    ]

    function feedbackService(
        $rootScope,
        $http
    ) {
        var service = {}

        /**
            Get all feedback
            @returns {*}
         **/
        service.getFeedback = function() {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/feedback?perpage=" + 1000
            }).then(getFeedbackComplete, getFeedbackFailed)

            function getFeedbackComplete(response) {
                //console.log("Get Feedback Successful: ", response)

                return response.data
            }

            function getFeedbackFailed(error) {
                //console.error("Get Feedback Error: ", error)

            }
        }

        /**
            Get single feedback
            @param {int} feedbackID
            @returns {*}
         **/
        service.getSingleFeedback = function(feedbackID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/feedback/" + feedbackID
            }).then(getSingleFeedbackComplete, getSingleFeedbackFailed)

            function getSingleFeedbackComplete(response) {
                //console.log("Get Single Feedback Successful: ", response)

                return response.data
            }

            function getSingleFeedbackFailed(error) {
                //console.error("Get Single Feedback Error: ", error)

            }
        }

        /**
            Submit feedback
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.submitFeedback = function(formData, successCallback, failureCallback) {
            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/feedback",
                data: formData
            }).then(submitFeedbackComplete, submitFeedbackFailed)

            function submitFeedbackComplete(response) {
                //console.log("Submit Feedback Successful: ", response)

                successCallback(response)
            }

            function submitFeedbackFailed(error) {
                //console.error("Submit Feedback Error: ", error)

                failureCallback(error)
            }
        }

        /**
            Edit existing feedback
            @param {int} feedbackID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.editFeedback = function(feedbackID, formData, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/feedback/" + feedbackID,
                data: formData
            }).then(editFeedbackComplete, editFeedbackFailed)

            function editFeedbackComplete(response) {
                //console.log("Edit Feedback Successful: ", response)

                successCallback(response)
            }

            function editFeedbackFailed(error) {
                //console.error("Edit Feedback Error: ", error)

                failureCallback(error)
            }
        }

        /**
            Delete existing feedback
            @param {int} feedbackID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.deleteFeedback = function(feedbackID, successCallback, failureCallback) {
            return $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/feedback/" + feedbackID
            }).then(deleteFeedbackComplete, deleteFeedbackFailed)

            function deleteFeedbackComplete(response) {
                //console.log("Delete Feedback Successful: ", response)

                successCallback(response)
            }

            function deleteFeedbackFailed(error) {
                //console.error("Delete Feedback Error: ", error)

                failureCallback(error)
            }
        }


        return service
    }
})()
